import { MediaSize } from '../enums';

// Precise screens

export const isMediaSizeXS = (size: MediaSize): boolean => {
    return size === MediaSize.XSMALL;
};

export const isMediaSizeMD = (size: MediaSize): boolean => {
    return size === MediaSize.MEDIUM;
};

export const isMediaSizeLG = (size: MediaSize): boolean => {
    return size === MediaSize.LARGE;
};

export const isMediaSizeXL = (size: MediaSize): boolean => {
    return size === MediaSize.XLARGE;
};

// Desktop first

export const isMediaSizeLessThanLG = (size: MediaSize): boolean => {
    return size === MediaSize.MEDIUM || size === MediaSize.SMALL || size === MediaSize.XSMALL;
};

export const isMediaSizeLessThanXL = (size: MediaSize): boolean => {
    return (
        size === MediaSize.MEDIUM || size === MediaSize.SMALL || size === MediaSize.XSMALL || size === MediaSize.LARGE
    );
};

export const isMediaSizeLessThanMD = (size: MediaSize): boolean => {
    return size === MediaSize.SMALL || size === MediaSize.XSMALL;
};

// Mobile first

export const isMediaSizeMoreThanSM = (size: MediaSize): boolean => {
    return (
        size === MediaSize.SMALL || size === MediaSize.MEDIUM || size === MediaSize.LARGE || size === MediaSize.XLARGE
    );
};

export const isMediaSizeMoreThanLG = (size: MediaSize): boolean => {
    return size === MediaSize.LARGE || size === MediaSize.XLARGE;
};
